import MsgManagerVue from '@/views/sa/msg-manager/msg-manager.vue';

const basePath = '/sa/msg-manager';
const role = 'sa'; // 角色身份

export const SA_MSG_MANAGER_INDEX = 'sa-msg-manager-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MsgManagerVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_MSG_MANAGER_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/msg-manager/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
